<div class="login-split-container">
  <div class="login-illustration">
    <div class="illustration-content">
      <h2 class="illustration-title">Authentication Manager</h2>
      <img
        ngSrc="/assets/img/data-management.png"
        alt="hero-image"
        class="illustration-img"
        width="400"
        height="300"
      />
    </div>
  </div>
  <div class="login-form-container">
    <div class="login-form-box">
      <!-- App Logo -->
      <div class="app-logo">
        <img
          ngSrc="/assets/img/logo.png"
          alt="AZAADI 2.0 Logo"
          class="logo-img"
          width="120"
          height="40"
          onerror="this.style.display='none'"
        />
      </div>
      <h1 class="login-title">AZAADI 2.0</h1>
      <p class="login-welcome">Welcome back! Please login to your account.</p>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="form-group">
          <label for="email">Email ID</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            required
            autocomplete="username"
            placeholder="Enter your email"
          />
          <div
            class="error"
            *ngIf="
              loginForm.get('email')?.touched && loginForm.get('email')?.invalid
            "
          >
            <span *ngIf="loginForm.get('email')?.errors?.['required']"
              >Email is required.</span
            >
            <span *ngIf="loginForm.get('email')?.errors?.['email']"
              >Invalid email format.</span
            >
          </div>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <div class="password-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              required
              autocomplete="current-password"
              placeholder="Enter your password"
            />
            <button
              type="button"
              class="toggle-password"
              (click)="showPassword = !showPassword"
              tabindex="-1"
            >
              <img
                *ngIf="showPassword"
                ngSrc="/assets/img/show.png"
                alt="Show password"
                aria-label="Show password"
                title="Show password"
                width="20"
                height="20"
              />
              <img
                *ngIf="!showPassword"
                ngSrc="/assets/img/hidden.png"
                alt="Hide password"
                aria-label="Hide password"
                title="Hide password"
                width="20"
                height="20"
              />
            </button>
          </div>
          <div
            class="error"
            *ngIf="
              loginForm.get('password')?.touched &&
              loginForm.get('password')?.invalid
            "
          >
            Password is required.
          </div>
        </div>
        <div class="form-actions">
          <a
            [routerLink]="['/forgot-password']"
            [queryParams]="redirectUrl ? { 'redirect-url': redirectUrl } : {}"
            class="forgot-link"
            >Forgot password?</a
          >
        </div>
        <button type="submit" class="login-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner"></span>
          <span *ngIf="!loading">Login</span>
        </button>
      </form>
      <footer class="login-footer">©2025 AZAADI. All rights reserved.</footer>
    </div>
  </div>
</div>
